export default "__VITE_ASSET__WIt8K0JW__"